import React, { Component, Fragment } from 'react';
import { Layout, Col, Affix, Spin } from 'antd';
import Drawer from 'react-motion-drawer';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import TopBar from '../components/layouts/TopBar';
import HeaderLogo from '../components/layouts/HeaderLogo';
import MenuBar from '../components/layouts/MenuBar';
import Footer from '../components/layouts/Footer';
import MenuMobile from '../components/layouts/MenuMobile';

import { getLayoutMenu } from '../actions';

import {loadJson} from '../utils/loadjson';
const viStr = loadJson( '/assets/vi.json');
const enStr = loadJson( '/assets/en.json');


class MainLayout extends Component {
  state = {
    drawerOpen: false,
  }

  componentDidMount = () => {
    this.props.getLayoutMenu();
  }

  onDrawerChange = status => {
    this.setState({ drawerOpen: status });
  }

  openDrawer = () => this.setState({ drawerOpen: true });

  closeDrawer = () => this.setState({ drawerOpen: false });

  render() {
    const { locale, menuLoaded } = this.props;
    if (!menuLoaded) {
      return (<div style={{ display: 'flex', flex: 1, height: '100vh', justifyContent: 'center', alignItems: 'center' }}>
        <Spin size="large" />
      </div>);
    }
    return (
      <Fragment>
        <Helmet>
          <title>
             {locale === 'en' 
             ?  enStr["HeaderLogo.TenKhoa"]
             :  viStr["HeaderLogo.TenKhoa"]
             }
          </title>
        </Helmet>
        <Drawer
          className='only-mobile'
          width={300}
          open={this.state.drawerOpen}
          onChange={this.onDrawerChange}
          drawerStyle={{ backgroundColor: '#FFF' }}
        >
          <MenuBar className='only-mobile' mode='inline' style={{ width: 300, marginTop: 50 }} closeDrawer={this.closeDrawer} />
        </Drawer>
        <Layout style={{ minHeight: '100vh' }}>
          <Layout.Header className='only-desktop' style={{ height: '100%', padding: 0 }}>
            <Col sm={{ span: 20, offset: 2 }} lg={{ span: 20, offset: 2 }}>
              <TopBar />
            </Col>
          </Layout.Header>
          <Layout.Header theme='light' className='only-mobile' style={{ height: '100%', padding: 0 }}>
            <Col sm={{ span: 20, offset: 2 }} lg={{ span: 20, offset: 2 }}>
              <MenuMobile openDrawer={this.openDrawer} />
            </Col>
          </Layout.Header>
          <Col sm={{ span: 20, offset: 2 }} lg={{ span: 20, offset: 2 }}>
            <HeaderLogo  lang = {locale} />
            <Affix>
              <MenuBar />
            </Affix>
          </Col>
          <Layout.Content>
            <Col
              style={{ background: '#FFFFFF', padding: '15px 20px' }}
              sm={{ span: 20, offset: 2 }}
              lg={{ span: 20, offset: 2 }}
            >
              {this.props.children}
            </Col>
          </Layout.Content>
          <Layout.Footer>
            <Footer />
          </Layout.Footer>
        </Layout>
      </Fragment>
    );
  }
}

export default withRouter(connect(state => ({
  locale: state.intl.locale,
  menuLoaded: state.app.menuLoaded,
}), {
  getLayoutMenu,
})(MainLayout));



// WEBPACK FOOTER //
// ./src/layouts/MainLayout.js